/* Halloween atmosphere: fog behind heroes, candle flicker, the cobweb in the first hero and a moth
   that crosses the screen once per visit. Settings come from #HalloweenConfig (decor snippet).
   Nothing here carries content; with JS off or reduced motion the page simply stays still. */

(() => {
  const root = document.documentElement;
  if (root.dataset.holiday !== 'halloween') return;

  let config = {};
  try {
    config = JSON.parse(document.getElementById('HalloweenConfig')?.textContent || '{}');
  } catch (error) {
    config = {};
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const heroSelector = '.holiday-hero__stage, .hero__media';

  const style = config.style || root.dataset.halloweenStyle || 'cute';
  if (style === 'spooky' && config.flicker && !reduceMotion) root.classList.add('hw-flicker');

  // Cute style: ghost, bats and sparkles on the first hero, as one layer over all slides.
  function addCute(scope = document) {
    const template = document.getElementById('HalloweenCute');
    if (style !== 'cute' || !template) return;
    const stage = scope.querySelector('[data-holiday-hero] hero-slider, .hero hero-slider, .holiday-hero__stage, .hero__media');
    if (!stage || stage.querySelector('.hw-cute')) return;
    // A hero with its own artwork already has characters; decorations would only collide with them.
    if (stage.querySelector('img, video')) return;
    if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
    stage.appendChild(template.content.cloneNode(true));
  }

  function addFog(scope = document) {
    if (style !== 'spooky' || !config.fog) return;
    scope.querySelectorAll(heroSelector).forEach((stage) => {
      if (stage.querySelector(':scope > .hw-fog')) return;
      const fog = document.createElement('div');
      fog.className = 'hw-fog';
      fog.setAttribute('aria-hidden', 'true');
      fog.innerHTML = '<div class="hw-fog__layer"></div><div class="hw-fog__layer"></div>';
      stage.appendChild(fog);
    });
  }

  function addCobweb(scope = document) {
    const template = document.getElementById('HalloweenCobweb');
    if (style !== 'spooky' || !config.cobweb || !template) return;
    // Hang the web on the whole first hero (not one slide) so it stays put while slides change.
    const stage = scope.querySelector('[data-holiday-hero] hero-slider, .hero hero-slider, .holiday-hero__stage, .hero__media');
    if (!stage || stage.querySelector('.hw-cobweb')) return;
    if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
    stage.appendChild(template.content.cloneNode(true));
  }

  function flyMoth() {
    const template = document.getElementById('HalloweenMoth');
    if (style !== 'spooky' || !config.moth || !template || reduceMotion || !window.gsap) return;
    try {
      if (sessionStorage.getItem('av-moth')) return;
      sessionStorage.setItem('av-moth', '1');
    } catch (error) {
      return;
    }

    const fragment = template.content.cloneNode(true);
    const moth = fragment.querySelector('.hw-moth');
    document.body.appendChild(fragment);

    const w = window.innerWidth;
    const h = window.innerHeight;
    const startY = h * (0.25 + Math.random() * 0.3);
    const { gsap } = window;

    gsap.set(moth, { x: -60, y: startY, rotation: 8 });
    const tl = gsap.timeline({ delay: 2.2, onComplete: () => moth.remove() });
    tl.to(moth, { x: w * 0.22, y: startY - h * 0.12, rotation: -6, duration: 2.2, ease: 'sine.inOut' })
      .to(moth, { x: w * 0.38, y: startY + h * 0.06, rotation: 14, duration: 1.6, ease: 'sine.inOut' })
      .to(moth, { x: w * 0.47, y: startY - h * 0.02, rotation: -10, duration: 0.7, ease: 'power1.inOut' })
      .to(moth, { x: w * 0.7, y: startY - h * 0.2, rotation: 4, duration: 2, ease: 'sine.inOut' })
      .to(moth, { x: w + 80, y: startY - h * 0.08, rotation: 12, duration: 1.8, ease: 'sine.in' });
  }

  function init(scope) {
    addFog(scope);
    addCobweb(scope);
    addCute(scope);
  }

  init(document);
  if (document.readyState === 'complete') flyMoth();
  else window.addEventListener('load', flyMoth, { once: true });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
